import { ReactNode } from "react";

import { useCopyToClipboard } from "@uidotdev/usehooks";

import { Icon } from "shared/ui/icon";
import { Img } from "shared/ui/img";

import fallbackValidatorUrl from "../assets/fallback-validator.png";

type Props = {
  className?: string;
  description?: ReactNode;
  imageUrl: string;
  imgBadge?: ReactNode;
  link?: string;
  name: string;
};

export const BasicInfo = (props: Props) => {
  const { imageUrl, name, link, imgBadge, description } = props;

  const [_, copy] = useCopyToClipboard();

  return (
    <div className="text-balticSea grid grid-cols-[34px_1fr] grid-rows-2 gap-x-2 text-xs leading-[18px]">
      <div className="relative row-span-2 size-8">
        <Img alt={name} fallbackUrl={fallbackValidatorUrl} src={imageUrl} />
        {imgBadge && (
          <div className="absolute -right-1 -bottom-1 flex size-4 items-center justify-center rounded-full bg-white p-0.5">
            {imgBadge}
          </div>
        )}
      </div>

      <div className="flex items-center gap-x-1">
        {name}
        {link && (
          <Icon
            className="text-santaGrey ml-0.5 size-3 cursor-pointer hover:brightness-95"
            name="copy"
            onClick={() => {
              copy(link);
            }}
          />
        )}
      </div>
      {description && <span className="text-santaGrey">{description}</span>}
    </div>
  );
};
